import { Stack as MuiStack, Typography as MuiTypography } from "@mui/material";
import { useTranslation } from "react-i18next";

const labelStyles = {
  fontSize: "10px",
  fontWeight: 600,
  lineHeight: "13px",
};

const valueStyles = {
  fontSize: "10px",
  lineHeight: "13px",
};

const VersionPreview = ({ version }) => {
  const { t } = useTranslation();

  return (
    <MuiStack
      gap={0.5}
      sx={{
        border: "1px solid #999999",
        borderRadius: "8px",
        margin: "10px",
        padding: "10px",
      }}
    >
      {/* <MuiStack direction="row" gap={4}>
        <MuiStack>
          <MuiTypography sx={labelStyles}>
            {t("studyRecruitment.labels.studyRecruitmentContact")}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>{version.name}</MuiTypography>
          <MuiTypography sx={valueStyles}>{version.email}</MuiTypography>
          <MuiTypography sx={valueStyles}>{version.phone}</MuiTypography>
        </MuiStack>
        <MuiStack>
          <MuiTypography sx={labelStyles}>
            {t("studyRecruitment.labels.displayOnPublicStudyPage")}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>
            {version.nameVisibility}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>
            {version.emailVisibility}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>
            {version.phoneVisibility}
          </MuiTypography>
        </MuiStack>
      </MuiStack>

      <MuiStack direction="row" gap={0.5}>
        <MuiStack sx={{ flex: 1 }}>
          <MuiTypography sx={labelStyles}>
            {t("studyRecruitment.labels.studyPreQuestionnaire")}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>
            {version.studyPrescreeningQuestionnaireUrl}
          </MuiTypography>
        </MuiStack>
        <MuiStack>
          <MuiTypography sx={labelStyles}>
            {t("studyRecruitment.labels.estTimeToComplete")}
          </MuiTypography>
          <MuiTypography sx={valueStyles}>
            {version.estTimeToComplete}
          </MuiTypography>
        </MuiStack>
      </MuiStack> */}

      <MuiStack>
        <MuiTypography sx={labelStyles}>
          {t("studyRecruitment.labels.officialStudyTitle")}
        </MuiTypography>
        <MuiTypography sx={valueStyles}>{version.title}</MuiTypography>
      </MuiStack>

      <MuiStack>
        <MuiTypography sx={labelStyles}>
          {t("studyRecruitment.labels.studyTitle")}
        </MuiTypography>
        <MuiTypography sx={valueStyles}>{version.shortTitle}</MuiTypography>
      </MuiStack>

      <MuiStack>
        <MuiTypography sx={labelStyles}>
          {t("studyRecruitment.labels.purpose")}
        </MuiTypography>
        <MuiTypography sx={valueStyles}>{version.briefSummary}</MuiTypography>
      </MuiStack>

      <MuiStack>
        <MuiTypography sx={labelStyles}>
          {t("studyRecruitment.labels.inclusionCriteria")}
        </MuiTypography>
        <MuiTypography sx={valueStyles}>
          {version.inclusionCriteria}
        </MuiTypography>
      </MuiStack>

      <MuiStack>
        <MuiTypography sx={labelStyles}>
          {t("studyRecruitment.labels.exclusionCriteria")}
        </MuiTypography>
        <MuiTypography sx={valueStyles}>
          {version.exclusionCriteria}
        </MuiTypography>
      </MuiStack>
    </MuiStack>
  );
};

export default VersionPreview;
